import { type BaseParams, NodeData } from './base';
import type { DatasourceMeta } from './factory';
import type { ContextItemData, LabelNameItemData, LabelValueItemData } from './types';

export interface CreateLabelNameContextParams extends BaseParams {
  datasourceUid: string;
  labelName: string;
}

export interface CreateLabelValueContextParams extends CreateLabelNameContextParams {
  labelValue: string;
  /** Filter operator (e.g., '=', '!=', '=~', '!~'). Defaults to '=' if not specified */
  operator?: string;
}

export class LabelNameNodeData extends NodeData {
  public datasourceUid: string;
  public datasourceType: string;
  public datasourceName: string;
  public labelName: string;
  public img?: string;

  constructor(params: CreateLabelNameContextParams & DatasourceMeta) {
    super({ ...params, id: `${params.datasourceUid}-${params.labelName}`, type: 'label_name' });
    this.datasourceUid = params.datasourceUid;
    this.datasourceType = params.datasourceType;
    this.datasourceName = params.datasourceName;
    this.labelName = params.labelName;
    this.text = params.labelName;
    this.img = params.img;
  }

  formatForLLM(codeElementIds?: string[]): ContextItemData {
    return {
      type: this.type,
      codeElementIds,
      bypassLimits: this.bypassLimits,
      data: {
        name: this.labelName,
        datasourceUid: this.datasourceUid,
        datasourceType: this.datasourceType,
        datasourceName: this.datasourceName,
        labelName: this.labelName,
        text: this.text,
      } satisfies LabelNameItemData,
    };
  }
}

export class LabelValueNodeData extends NodeData {
  public datasourceUid: string;
  public datasourceType: string;
  public datasourceName: string;
  public labelName: string;
  public labelValue: string;
  public img?: string;
  public operator: string;

  constructor(params: CreateLabelValueContextParams & DatasourceMeta) {
    super({
      ...params,
      id: `${params.datasourceUid}-${params.labelName}-${params.labelValue}-${params.operator || '='}`,
      type: 'label_value',
    });
    this.datasourceUid = params.datasourceUid;
    this.datasourceType = params.datasourceType;
    this.datasourceName = params.datasourceName;
    this.labelName = params.labelName;
    this.labelValue = params.labelValue;
    this.text = params.labelValue;
    this.img = params.img;
    this.operator = params.operator || '=';
  }

  formatForLLM(codeElementIds?: string[]): ContextItemData {
    return {
      type: this.type,
      codeElementIds,
      bypassLimits: this.bypassLimits,
      data: {
        name: this.labelValue,
        datasourceUid: this.datasourceUid,
        datasourceType: this.datasourceType,
        datasourceName: this.datasourceName,
        labelName: this.labelName,
        labelValue: this.labelValue,
        text: this.text,
        operator: this.operator,
      } satisfies LabelValueItemData,
    };
  }
}
